package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

/**
 * Objet de départ associé à un personnage pré-tiré.
 *
 * Sérialisé dans la colonne jsonb `premade_characters.inventory` (même approche que `sheet`).
 * L'image vit dans le bucket `inventory` sous `premade_items/{tableId}/{itemId}.ext`.
 * À la création d'un personnage depuis un pré-tiré, chaque objet est recopié dans l'inventaire réel
 * du personnage (données + image).
 */
@Serializable
data class PreMadeInventoryItem(
    @SerialName("id")
    val id: String,

    @SerialName("name")
    val name: String,

    @SerialName("category")
    val category: ItemCategory,

    @SerialName("quantity")
    val quantity: Int = 1,

    @SerialName("image_url")
    val imageUrl: String? = null,

    @Transient
    val signedImageUrl: String? = null,
)
